import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class NotasService {

  constructor( private http: HttpClient ) {}
  getNotas(){
    return this.http.get("assets/data/notas.json")
  }
}
